export default __webpack_public_path__ + "static/media/newspaper.c236288f.png";